import { Link } from "react-router-dom";
import type { Anime } from "@/types";

interface RelatedAnimeProps {
  list: Anime[];
}

export default function RelatedAnime({ list }: RelatedAnimeProps) {
  if (list.length === 0) return null;

  return (
    <section className="mt-10 md:mt-14">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 flex items-center gap-2">
          <i className="ri-magic-line text-primary-500"></i>
          相关推荐
        </h2>
        <span className="text-xs text-foreground-500 hidden sm:block">根据分类与热度为你推荐</span>
      </div>

      <div className="flex gap-3 md:gap-4 overflow-x-auto pb-3 no-scrollbar">
        {list.map((anime) => (
          <Link
            key={anime.id}
            to={`/anime/detail/${anime.id}`}
            className="group w-36 md:w-44 shrink-0 rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all cursor-pointer"
          >
            <div className="w-full aspect-[2/3] overflow-hidden bg-background-200">
              <img
                src={anime.cover}
                alt={`${anime.title} 封面`}
                title={`${anime.title} - 51动漫`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-2.5">
              <h3 className="font-heading font-semibold text-sm text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                {anime.title}
              </h3>
              <div className="mt-1 flex items-center gap-1 text-[11px] text-foreground-500">
                <i className="ri-star-fill text-accent-500"></i>
                {anime.rating.toFixed(1)}
                <span className="mx-0.5">·</span>
                {anime.year}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}